import { all, call } from 'redux-saga/effects';

import dnsSagas from './dns/dnsSagas';

export default function* sagas() {
	yield all([call(dnsSagas)]);
}
